import { render, staticRenderFns } from "./_taskIsQueued.vue?vue&type=template&id=2f561db2"
import script from "./_taskIsQueued.vue?vue&type=script&lang=js"
export * from "./_taskIsQueued.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports